import React from 'react';
import screensSteps from '../../../../../constants/screens/screensSteps';
import { useSelector } from 'react-redux';
import screenFinder from '../../../../../constants/screens/screenFinder';
import GlobalSubTopBar from '../../../../../utils/components/GlobalSubTopBar';

function EndScreenTopbar({ isAgentScreen = false }) {
  const currentStep = useSelector(state => state.endScreen.etc.endScreenStep);
  const data = screenFinder('endscreen');
  const creationType = useSelector(state => state.endScreen.etc.creationType);

  return (
    <GlobalSubTopBar
      data={data}
      currentStep={currentStep}
      backRoute={data.dashboardPath}
      steps={screensSteps.slice(1)}
      creationType={creationType}
      isAgentScreen={isAgentScreen}
    />
  );
}

export default EndScreenTopbar;
